import { configureStore } from '@reduxjs/toolkit'

import strategyReducer from './reducers/strategyReducer'
import alertReducer from './reducers/alertReducer'
import exchangesReducer from './reducers/exchangesReducer'
import usersReducer from './reducers/usersReducer'
import keysSetsReducer from './reducers/keysSetsReducer'

const store = configureStore({
  reducer: {
    strategy: strategyReducer,
    keysSets: keysSetsReducer,
    users: usersReducer,
    exchanges: exchangesReducer,
    alert: alertReducer,
  }
})

export default store
